<h1 mat-dialog-title>{{ title }}</h1>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div mat-dialog-content class="it-content">
    <div class="row">
      <div class="col-12 mb-3">
        <span class="dialog-section">
          <mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}
        </span>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.name' | translate }}</mat-label>
        <input matInput formControlName="name" />
        <mat-error [control]="form.controls.name"></mat-error>
      </mat-form-field>

      <div class="col-12 mb-2">
        <span class="dialog-section"> <mat-icon>set_meal</mat-icon> {{ 'field.bones' | translate }} </span>
      </div>
      <p class="it-hint" [class.it-hint-locked]="isReadOnly">
        <mat-icon class="it-hint-icon">{{ isReadOnly ? 'lock' : 'info' }}</mat-icon>
        <span>{{
          (isReadOnly ? 'page.ishikawaTemplates.readOnlyHint' : 'page.ishikawaTemplates.hint') | translate: hintParams
        }}</span>
      </p>

      <div
        class="it-bone-list"
        cdkDropList
        formArrayName="bones"
        [cdkDropListDisabled]="isReadOnly"
        (cdkDropListDropped)="onBoneDrop($event)"
      >
        @for (row of boneRows(); track row.control; let index = $index) {
          @if (row.sectionLabelKey) {
            <div class="it-section-label">{{ row.sectionLabelKey | translate }}</div>
          }
          <div class="it-bone-row" cdkDrag [formGroupName]="index">
            @if (!isReadOnly) {
              <mat-icon
                class="it-drag-handle"
                cdkDragHandle
                [matTooltip]="'page.ishikawaTemplates.dragToReorder' | translate"
                >drag_indicator</mat-icon
              >
            }
            <button
              type="button"
              class="it-style-button"
              [style.--it-bone-color]="row.color"
              [disabled]="isReadOnly"
              [matMenuTriggerFor]="styleMenu"
              [matMenuTriggerData]="{ index: index }"
              [matTooltip]="'page.ishikawaTemplates.boneStyle' | translate"
              [attr.aria-label]="'page.ishikawaTemplates.boneStyle' | translate"
            >
              <mat-icon>{{ row.icon }}</mat-icon>
            </button>
            <mat-form-field appearance="outline" class="it-bone-name" subscriptSizing="dynamic">
              <mat-label>{{ 'page.ishikawaTemplates.boneName' | translate }}</mat-label>
              <input matInput formControlName="name" />
              <mat-error [control]="row.control.controls.name"></mat-error>
            </mat-form-field>
            @if (!isReadOnly) {
              <button
                mat-icon-button
                type="button"
                [disabled]="!canRemoveBone()"
                [matTooltip]="'page.ishikawaTemplates.removeBone' | translate"
                (click)="onRemoveBone(index)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            }
          </div>
        }
      </div>

      @if (hasDuplicateBoneNames()) {
        <div class="it-error">{{ 'page.ishikawaTemplates.duplicateBoneNames' | translate }}</div>
      }

      @if (hasInvalidBoneCount()) {
        <div class="it-error">{{ 'page.ishikawaTemplates.boneCountRange' | translate: hintParams }}</div>
      }

      @if (!isReadOnly) {
        <div class="it-add-row">
          <button mat-stroked-button type="button" [disabled]="!canAddBone()" (click)="onAddBone()">
            <mat-icon>add</mat-icon>
            {{ 'page.ishikawaTemplates.addBone' | translate }}
          </button>
          @if (!canAddBone()) {
            <span class="it-muted">{{ 'page.ishikawaTemplates.maxBonesReached' | translate: hintParams }}</span>
          }
        </div>
      }
    </div>
  </div>
  <mat-dialog-actions align="end">
    <button matButton="tonal" type="button" mat-dialog-close>
      {{ (isReadOnly ? 'button.close' : 'button.cancel') | translate }}
    </button>
    @if (!isReadOnly) {
      <button mat-flat-button type="submit" [disabled]="isSaving()">{{ submitButtonText }}</button>
    }
  </mat-dialog-actions>
</form>

<!-- One menu for the whole bone appearance: the trigger already previews it, so colour and icon belong together. -->
<mat-menu #styleMenu="matMenu" class="it-style-menu-panel">
  <ng-template matMenuContent let-index="index">
    <div class="it-style-menu" (click)="$event.stopPropagation()">
      <span class="it-style-label">{{ 'page.ishikawaTemplates.color' | translate }}</span>
      <div class="it-color-grid">
        @for (color of colors; track color) {
          <button
            type="button"
            class="it-color-option"
            [class.is-selected]="color === boneRows()[index].color"
            [style.background]="color"
            [attr.aria-label]="color"
            [attr.aria-pressed]="color === boneRows()[index].color"
            (click)="onSelectColor(index, color)"
          ></button>
        }
      </div>
      <span class="it-style-label">{{ 'page.ishikawaTemplates.icon' | translate }}</span>
      <div class="it-icon-grid">
        @for (icon of icons; track icon) {
          <button
            type="button"
            class="it-icon-option"
            [class.is-selected]="icon === boneRows()[index].icon"
            [style.--it-bone-color]="boneRows()[index].color"
            [attr.aria-label]="icon"
            [attr.aria-pressed]="icon === boneRows()[index].icon"
            (click)="onSelectIcon(index, icon)"
          >
            <mat-icon>{{ icon }}</mat-icon>
          </button>
        }
      </div>
    </div>
  </ng-template>
</mat-menu>
